import React from 'react';
import { CaptionsChildViewContextType } from './types';

const CaptionsChildViewContext = React.createContext<
  CaptionsChildViewContextType | undefined
>(undefined);

export default CaptionsChildViewContext;
